import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d56ff87e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap_screen" }
const _hoisted_2 = { class: "status_bar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "other_profile" }, " 아바타 페르소나 생성 ", -1))
const _hoisted_4 = { class: "scroll" }
const _hoisted_5 = { class: "wrap_chat_screen" }
const _hoisted_6 = { class: "persona-form" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "world" }, "살고 있는 세계", -1))
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "era" }, "시대", -1))
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "place" }, "장소", -1))
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "happenings" }, "해프닝", -1))
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "이름", -1))
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "age" }, "나이", -1))
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "tribe" }, "종족", -1))
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "gender" }, "성별", -1))
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "work" }, "하는 일", -1))
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "goal" }, "인생목표", -1))
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "value" }, "가치관", -1))
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "motivation" }, "동기부여", -1))
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "personality" }, "성격", -1))
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mbti" }, "MBTI", -1))
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "favorite" }, "좋아하는 것", -1))
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "specialty" }, "특기", -1))
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "topic" }, "주제", -1))
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "speaking_habits" }, "말하는 습관", -1))

import { ref } from 'vue';
import {
  tabStore,
  userStore,
  tutorialStore,
} from '../stores/storeAuth';
import { pushPage } from '@utils/route.helper';
import { errorType } from '@interface/error';
import {
  postAvatar,
  getAvatarList,
} from '@apis/voicechat';


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonaChat',
  setup(__props) {

const tabData = tabStore();
const showMobileMenu = () => {
  tabData.sideMenu = true;
};

const personaMessages = ref([]);
const messageInput = ref('');
const isListening = ref(false);
const message = ref('');
const world = ref('우주 외계 행성');
const era = ref('미래');
const place = ref('지구');
const happenings = ref('오염과 자연 파괴');
const name = ref('마징가');
const age = ref('30');
const tribe = ref('로봇');
const gender = ref('남자');
const work = ref('정착');
const goal = ref('평화로운 삶');
const value = ref('자연');
const motivation = ref('자연보호');
const personality = ref('평화롭고 자상하며 이야기를 잘 들어주는');
const mbti = ref('INTJ');
const favorite = ref('자연의 동물과 식물');
const specialty = ref('산책, 그림 그리기');
const topic = ref('자연보호');
const speakingHabits = ref('"징가~"');

const postAvatarInfo = async () => {
  const params = {
    world: world.value,
    era: era.value,
    place: place.value,
    happenings: happenings.value,
    name: name.value,
    age: age.value,
    tribe: tribe.value,
    gender: gender.value,
    work: work.value,
    goal: goal.value,
    value: value.value,
    motivation: motivation.value,
    personality: personality.value,
    mbti: mbti.value,
    favorite: favorite.value,
    specialty: specialty.value,
    topic: topic.value,
    speaking_habits: speakingHabits.value,
  };
  try {
    const result = await postAvatar(params);
    console.log(result);
    // AntNotification.success({ message: '상품을 등록했습니다.' });
    // entryList.value = result.data.data;
    // await getNoriceInfo();
  } catch (error) {
    // AntNotification.error({ message: error?.message });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_font_awesome_icon, {
        class: "chevron",
        icon: "fa-solid fa-bars",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showMobileMenu()))
      }),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((world).value = $event)),
                placeholder: "Enter World"
              }, null, 512), [
                [_vModelText, world.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((era).value = $event)),
                placeholder: "Enter Era"
              }, null, 512), [
                [_vModelText, era.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((place).value = $event)),
                placeholder: "Enter Place"
              }, null, 512), [
                [_vModelText, place.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((happenings).value = $event)),
                placeholder: "Enter Happenings"
              }, null, 512), [
                [_vModelText, happenings.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((name).value = $event)),
                placeholder: "Enter Name"
              }, null, 512), [
                [_vModelText, name.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((age).value = $event)),
                placeholder: "Enter Age"
              }, null, 512), [
                [_vModelText, age.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((tribe).value = $event)),
                placeholder: "Enter Tribe"
              }, null, 512), [
                [_vModelText, tribe.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((gender).value = $event)),
                placeholder: "Enter Gender"
              }, null, 512), [
                [_vModelText, gender.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((work).value = $event)),
                placeholder: "Enter Work"
              }, null, 512), [
                [_vModelText, work.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((goal).value = $event)),
                placeholder: "Enter Goal"
              }, null, 512), [
                [_vModelText, goal.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((value).value = $event)),
                placeholder: "Enter Value"
              }, null, 512), [
                [_vModelText, value.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((motivation).value = $event)),
                placeholder: "Enter Motivation"
              }, null, 512), [
                [_vModelText, motivation.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((personality).value = $event)),
                placeholder: "Enter Personality"
              }, null, 512), [
                [_vModelText, personality.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((mbti).value = $event)),
                placeholder: "Enter MBTI"
              }, null, 512), [
                [_vModelText, mbti.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((favorite).value = $event)),
                placeholder: "Enter Favorite"
              }, null, 512), [
                [_vModelText, favorite.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((specialty).value = $event)),
                placeholder: "Enter Specialty"
              }, null, 512), [
                [_vModelText, specialty.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((topic).value = $event)),
                placeholder: "Enter Topic"
              }, null, 512), [
                [_vModelText, topic.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((speakingHabits).value = $event)),
                placeholder: "Enter Speaking Habits"
              }, null, 512), [
                [_vModelText, speakingHabits.value]
              ])
            ]),
            _createElementVNode("div", { class: "wrap_button" }, [
              _createElementVNode("div", {
                class: "button_okay",
                onClick: postAvatarInfo
              }, " 생성하기 ")
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})